import * as React from 'react';

import { SearchResults } from 'react-instantsearch-core';
import { connectStateResults } from 'react-instantsearch-dom';

import { styled } from '~/styled';

import translations from './translations.json';

const Message = styled.p(({ theme }) => {
  return `
    margin: 0;
    color: ${theme.colors.n500};
    line-height: ${theme.lineHeights.lineheight24};
    margin-top: ${theme.space.space24};
  `;
});

export const State = ({
  searchResults,
  title,
}: {
  searchResults: SearchResults;
  title?: string;
}) => {
  const locale = 'en';

  const hasResults = searchResults && searchResults.nbHits !== 0;
  const message = title
    ? translations[locale].noResultsForType.replace('{{type}}', title)
    : translations[locale].noResults;

  return <Message hidden={hasResults}>{message}</Message>;
};

// https://www.algolia.com/doc/api-reference/widgets/state-results/react/#connector
export const SearchState = connectStateResults(State);
